<template>
  <div>
    <div v-if="pdv" class="media is-align-items-center mb-10">
      <figure class="media-left">
        <img height="30" width="30" :src="getImg(pdv.logo)">
      </figure>
      <div class="media-content">
        <p class="is-size-7 has-text-grid-1">{{ $t('tableauDeBord.listeRecom.copiePdv.pdv') }}</p>
        <p class="has-text-weight-bold">{{ pdv.nom }}</p>
        <p class="is-size-7 has-text-default">{{ pdv.adresse }}</p>
      </div>
    </div>
    <div v-if="enseigne" class="media is-align-items-center">
      <figure class="media-left">
        <img height="30" width="30" :src="getImg(enseigne.logo)">
      </figure>
      <div class="media-content">
        <p class="is-size-7 has-text-grid-1">{{ $t('tableauDeBord.listeRecom.copiePdv.enseigne') }}</p>
        <p class="has-text-weight-bold">{{ enseigne.nom }}</p>
        <p class="is-size-7 has-text-default">{{ enseigne.adresse }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getImg } from '@/services/general/general';

export default {
  name: 'BlocInfoTiers',
  props: {
    pdv: {
      type: Object,
      default: null,
    },
    enseigne: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getImg,
  },
};
</script>
